module.exports = __webpack_public_path__ + "img/banner1.9c5177e.jpg";